import React, {FC} from 'react';

import {Anchor} from '../../../../../libs/shared/ui/src/components/reposition/repositionHelpers';
import {useAppSelector} from '../../../../helpers/appReduxHelpers';
import {SandboxScenariosEnum} from '../../../../helpers/sandbox/sandboxScenarioHelpers';
import {getIsSandboxGeneralInboxTicketingEnabled} from '../../../../store/data/inboxes/inboxesSelectors';
import {FirstMessageEducationTip} from './firstMessageEducationTip';
import {SandboxEducationTipCoordinator} from './sandboxEducationTipCoordinator';

/*
 * Props.
 */

interface FirstMessageEducationTipCoordinatorProps {
  anchor: Anchor;
  conversationId: number | undefined;
}

/*
 * Component.
 */

export const FirstMessageEducationTipCoordinator: FC<FirstMessageEducationTipCoordinatorProps> = (props) => {
  const isGeneralSandboxInboxTicketing = useAppSelector(getIsSandboxGeneralInboxTicketingEnabled);

  return (
    <SandboxEducationTipCoordinator
      anchor={props.anchor}
      conversationId={props.conversationId}
      scenario={
        isGeneralSandboxInboxTicketing
          ? SandboxScenariosEnum.SCENARIO5_ACT1
          : SandboxScenariosEnum.SCENARIO3_ACT1
      }
      step="acknowledge-message-prompt"
      isEligible
      renderEducationTip={(tipProps) => <FirstMessageEducationTip {...tipProps} />}
    />
  );
};
